import React from "react";

const CTA = (props) => {

        return <div className={props.active}>
            <div className="cta">
                <img className="cta__image" alt="CTA" src={props.cta.heroImage ? props.cta.heroImage.url  : ''}/>
                <div dangerouslySetInnerHTML={{ __html: props.cta.introText}} ></div>
                <div className="cta__button">
                    <a href={props.cta.button ? props.cta.button.value : ''} className={'button button-secondary'}>{props.cta.button ? props.cta.button.customText : ''} </a>
                </div>

            </div>
        </div>

}

CTA.defaultProps = {
    active: [],
    cta: [
      heroImage => null,
      button => null
]
};
export default CTA


// WEBPACK FOOTER //
// ./src/components/elements/modals/CTA.js